import { useEffect, useState } from "react";
import monthFilterDefault from '@/pages/dashboard/filterPageComponents/overview/monthFilterDefault';
import { formatFilterValues, formatSingleTime } from '@/pages/dashboard/utils/utils';
import { overviewMonthlyRequest } from "../../pages/overview/_config/overviewMonthlyRequest";
import { getDefaultUtcDateValue } from "../../utils/dateUtils";

/**
 * 按照接口区分为不同model
 * hook名称规范：use+接口名称+Data
 * @param parentProps 父页面所有props
 * @param props: timeZone 时区信息，realtime特有
 * @param props: dispatch dva  dispatch方法
 * @returns 
 * 获取数据的逻辑：dva中有数据则取dva中的数据，否则自己通过接口请求
 */

const useMonthMetricsModel = (
  parentProps: any, 
  formValue: any, 
  dispatch: any, 
  filterLoading: boolean, 
  regionDataType: string,
  overviewReqType = 'normal'
) => {
  const { gameCode} = parentProps;
  const formVal = formValue || monthFilterDefault;
  const [componentData, setComponentData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // 点击筛选器的时候
  useEffect(() => {
    if (!formValue) return;
    if (!filterLoading) {
      geMetricsDataFunc();
    }
  }, [formValue]);


  const geMetricsDataFunc = (isRefresh?: boolean) => {
    const { filterValue, diff, timeType } = formVal;
    const { rangeTime, ...filters } = filterValue;
    const defaultTimeRange = getDefaultUtcDateValue(formVal?.timeType,rangeTime);
    const rangeTimeArr = diff ?  defaultTimeRange : formatSingleTime(rangeTime, timeType);
    const [start, end] = rangeTimeArr;
    const params = {
      game_code: gameCode,
      filters: formatFilterValues(filters),
      start_time: start,
      end_time: end,
      by_type: regionDataType,
    };
    setLoading(!isRefresh);
    overviewMonthlyRequest.getMonthMetricsUsers[overviewReqType](params).then((result: any) => {
      setError('');
      setLoading(false);
      setComponentData(result);
      dispatch({
        type: "overview/getMonthMetricsDataFunc",
        payload: {
          result
        }
      });
    }).catch((err: any) => {
      setError(err);
      setLoading(false);
    });
  };
  return {
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    componentData,
    loading,
    error,
  };
};

export default useMonthMetricsModel;